export const Service = {
  methods: {
    //get service data
    fetchData() {
      this.loader = true;
      this.mTop = true;

      this.$axiosApi
        .get(`https://card.nomin.mn/api/service`)
        .then((response) => {
          this.serviceData = response.data.data;
          this.mTop = false;
        })
        .catch(() => {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
    checkByRegister(register) {
      var tokenId = localStorage.getItem("authToken");
      var userOwnData = this.$auth.getMe();
      if (tokenId == null || userOwnData == null) {
        this.RedirectLogin();
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      var registerNo = register;
      return this.$axiosApi
        .post(`card/checkByRegister`, { registerNo })
        .then((response) => {
          return response.data;
        })
        .catch(() => {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
    qrRead(qrData) {
      var tokenId = localStorage.getItem("authToken");
      var userOwnData = this.$auth.getMe();
      if (tokenId == null || userOwnData == null) {
        this.RedirectLogin();
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      return this.$axiosApi
        .post(`card/read-qr`, {
          qrData,
          tokenId,
        })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          this.errorModal = true;
          this.errorMessage = error.message;
          //   this.RedirectLogin();
          //   this.$auth.destroyToken();
          //   this.$auth.removeMe();
          //   this.$router.push({ name: "login" });
        });
    },
  },
};
